import { render, staticRenderFns } from "./roommate-form.vue?vue&type=template&id=2fd7d3ef"
import script from "./roommate-form.vue?vue&type=script&lang=js"
export * from "./roommate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports